import React from "react";

interface Props {
  heading: string;
  subHeading?: string;
  image: string;
}

const MadeInLancasterHeader = ({
  heading,
  subHeading,
  image,
}: Props): JSX.Element => (
  <div className="container hero hero--md hero--lancaster hero--category">
    <picture>
      <source
        srcSet="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        media="(max-width:599px)"
      />
      <img
        className="hero__logo"
        src="//cdnimg.webstaurantstore.com/uploads/images/2018/5/mil-logo.png"
        alt={heading}
      />
    </picture>
    <div className="hero-container container hero-container--lancaster">
      <h1 className="hero-text hero-text--medium hero-text--left">{heading}</h1>
      {subHeading && (
        <div className="hero-text hero-text--xsmall">{subHeading}</div>
      )}
    </div>
    <picture>
      <source
        srcSet="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
        media="(max-width:599px)"
      />
      <source
        srcSet="//cdnimg.webstaurantstore.com/uploads/images/2018/5/mil-hero-mobile-4.jpg"
        media="(min-width: 600px) and (max-width:946px)"
      />
      <img className="hero-image" src={image} alt={heading} />
    </picture>
  </div>
);

export default MadeInLancasterHeader;
